module.exports = __webpack_public_path__ + "img/20.35bb0f62.jpg";